import { Link } from "react-router-dom";
import { PlusTierList } from "@ugg/shared/components/SummonerProfiles/plus-tier-list/PlusTierList";
import { AppRoutes } from "@ugg/shared/routes/app-routes";

const buildLoginHref = (returnPath: string) => `${AppRoutes.LOGIN}?redirect_url=${encodeURIComponent(returnPath)}`;

export function SummonerProfilePlusTierListPage() {
  return (
    <div className="w-[1016px] max-md:w-full">
      <PlusTierList PlusLink={Link} buildLoginHref={buildLoginHref} />
    </div>
  );
}
